module.exports = __webpack_public_path__ + "img/beneficio1.f9282406.svg";